import { Image, Wrapper } from './splash_screen.styles';

import { VENDOR_BUSINESS_NAME } from '../constants';

import logo from '../static/splash/logo.svg';

export default function SplashScreen() {
  return (
    <Wrapper>
      <Image alt={VENDOR_BUSINESS_NAME} src={logo} />
    </Wrapper>
  );
}
